const listDomainZone = ["com", "org", "net", "info", "biz", "name", "edu", "gov", "mil", "int", "aero", "jobs",
    "mobi", "museum", "coop", "travel", "app", "blog", "shop", "xyz", "tech", "online", "arpa", "io", "site", "space",
    "live", "fun", "club", "store", "games", "art",];
const listCountryDomain = ["us", "uk", "de", "fe", "ru", "cn", "jp", "ca", "in", "br", "au", "fr", "id", "it",
    "gl", "es", "mx", "nl", "se", "pl", "tr", "kr", "sg", "za",];
const combinedDomainZones = listDomainZone.concat(listCountryDomain);
const domainZonePattern = combinedDomainZones.join("|");
const urlRegex = new RegExp(`((https?:\\/\\/)?[\\w.-]+\\.(${domainZonePattern})(\\/[\\w./?%&=-]*)?)`, "gi");
const parseTextWithLinks = (text, linkConverter) => {
    return text.replace(urlRegex, (url) => {
        const href = url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;
        const visible = url;
        return linkConverter(visible, href);
    });
};
export const parseTextWithLinksToColoredRichText = (text, color, hover) => {
    const linkConverter = (srcText, href) => {
        const linkColor = hover && hover.link === href ? hover.color : color;
        // return `<rt underline='true' underlineColor='${linkColor}' underlineThicknessMultiplier='2' underlineOffset='4px' color='${linkColor}' hyperlink='${href}'>${srcText}</rt>`;
        return `<rt color='${linkColor}' hyperlink='${href}'>${srcText}</rt>`;
    };
    return parseTextWithLinks(text, linkConverter);
};
